import { Action, IntentProject } from "types/generated";
import { AccessResult, checkAllowedAction } from "utils/access";

/**
 * Hook that returns whether the current user can review intent resource operations
 * on the given intent project. Backed by `Action.IntentResourceOperationReview` on
 * the project's `allowedActions`.
 * @param project The intent project the operation belongs to
 * @returns {AccessResult} Object indicating if the user can review and an optional message
 *   describing why access was denied (use to render a tooltip on a disabled button)
 */
const useCanReviewIntentResourceOperation = (project: IntentProject | undefined): AccessResult =>
  checkAllowedAction(project, Action.IntentResourceOperationReview);

export default useCanReviewIntentResourceOperation;
